import { formatDate } from '../../../../utils/Utils';

/**
 * Formata 'YYYY-MM-DD HH:MM:SS' (fuso do servidor) com formatDate() do projeto.
 * Mesmo parse usado em AuditRow.js.
 * @param {string|null} dateStr
 * @returns {string}
 */
export function formatServerDateTime(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * Só a hora (HH:MM) de 'YYYY-MM-DD HH:MM:SS', para a linha de próxima tentativa.
 * @param {string|null} dateStr
 * @returns {string}
 */
export function formatServerTime(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

/**
 * Converte 'YYYY-MM-DD HH:MM:SS' em Date, ou null quando não dá.
 * @param {string|null} dateStr
 * @returns {Date|null}
 */
export function parseServerDate(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr.replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Rótulo e cor do Chip de status (mesmo vocabulário de WhatsAppOutbox.php) */
export const STATUS_META = {
  pending: { label: 'Pendente', color: 'info' },
  processing: { label: 'Em envio', color: 'warning' },
  sent: { label: 'Enviada', color: 'success' },
  failed: { label: 'Falha', color: 'error' },
  canceled: { label: 'Cancelada', color: 'default' },
};

/** last_error que o despachante grava ao adiar a linha por limite de envio */
export const ERROR_RATE_LIMITED = 'RATE_LIMITED';
